import { useState, useRef, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export function useResizeObserver(node) {
  let [resizeDimensions, setResizeDimensions] = useState(null);

  let observer = useRef(
    // ([entry]): only watching first elem since we're expecting to observe only one elem per useResize
    new ResizeObserver(([entry]) => {
      const { contentRect } = entry;
      setResizeDimensions(contentRect);
    })
  );

  useEffect(() => {
    let { current: currentObserver } = observer;
    currentObserver.disconnect();
    if (node && 'current' in node && node.current) {
      currentObserver.observe(node.current);
    } else if (node) {
      currentObserver.observe(node);
    }

    return () => {
      currentObserver.disconnect();
    };
  }, [node]);

  return [resizeDimensions];
}
